export default __webpack_public_path__ + "bitcoin-logo.png";